import Experience from './Experience.js'
import Camera from './Camera.js'
import { Howl, Howler } from 'howler'
import EventEmitter from './Utils/EventEmitter.js'
import * as THREE from 'three'

export default class AudioManager extends EventEmitter
{
    constructor()
    {
        super()

        // Mute all sounds initially
        Howler.mute(true);

        this.experience = new Experience()
        this.camera = this.experience.camera
        this.muteButton = document.getElementById('mute-button')

        this.muteButton.addEventListener('click', ()=> { this.toggleMute() })
        
        this.loadedSounds = 0;
        this.sounds = {
            cube_hover: new Howl
            ({ 
                src: 'audio/ui/hc_cube_hover.mp3',
                volume: 0.2,
                onload: () =>
                {
                    this.loadedSounds++;
                    const progressCount = this.ProgressCount()
                    this.trigger('soundLoaded', [progressCount])
                }
            }),
            
            cube_click: new Howl
            ({ 
                src: 'audio/ui/hc_cube_click.mp3',
                volume: 0.3,
                onload: () =>
                {
                    this.loadedSounds++;
                    const progressCount = this.ProgressCount()
                    this.trigger('soundLoaded', [progressCount])
                }
            }),
            
            cube_release: new Howl
            ({ 
                src: 'audio/ui/hc_cube_release.mp3',
                volume: 0.2,
                onload: () =>
                {
                    this.loadedSounds++;
                    const progressCount = this.ProgressCount()
                    this.trigger('soundLoaded', [progressCount])
                }
            }),

            click: new Howl 
            ({
                src: 'audio/ui/hc_cube_hover.mp3',
                volume: 0.05,
                onload: () =>
                {
                    this.loadedSounds++;
                    const progressCount = this.ProgressCount()
                    this.trigger('soundLoaded', [progressCount])
                }
            }),
            
            dark: new Howl
            ({ 
                src: 'audio/hc_dark_ambience_1.mp3',
                loop: true,
                volume: 0.1,
                
                onload: () => {
                    this.loadedSounds++;
                    const progressCount = this.ProgressCount()
                    this.trigger('soundLoaded', [progressCount])
                    
                    this.sounds.dark.play();
                    this.sounds.dark.fade(0.0, 0.1, 2000);
                }
            })
        }

        this.totalSounds = Object.keys(this.sounds).length;
    }



    playSound(soundName)
    {
        
        // For example: send in 'cube_hover'
        if(this.sounds[soundName]) {
            this.sounds[soundName].play();
        } else {
            console.warn(`Sound "${soundName}" not found`);
        }
    }

    toggleMute()
    {
        const isMuted = Howler._muted;
        Howler.mute(!isMuted);

        this.muteButton.classList.toggle('audio-off', !isMuted);
    }

    ProgressCount()
    {
        return this.loadedSounds
    }
    
}